<script lang="ts" setup>
import { historyCommonConfig as config, historyDeleteModalTheme } from './configs/common'
import HistoryPageDefault from './components/HistoryPage.default.vue'




import { loadBrandComponent } from '@/utils/loadBrandConfig'

const HistoryPage = loadBrandComponent({ rocnovel: HistoryPageDefault })
</script>

<template>
  <HistoryPage :config="config" :delete-modal-theme="historyDeleteModalTheme" />
</template>
